import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { WHITEBOARD_URL, WHITEBOARD_BY_TOKEN_URL } from '../constants/ApiURLConst';
import { ApiResponse } from '../model/apiresponse';
import { RestApiService } from '../service/restapi.service';
import { SafeResourceUrl } from '@angular/platform-browser';

declare var WhiteboardTeam: any;

@Component({
  selector: 'app-whiteboard',
  templateUrl: './whiteboard.component.html',
  styleUrls: ['./whiteboard.component.css'],
})
export class WhiteboardComponent implements OnInit {
  public lessonInvitationId: string;
  public token: string;
  public whiteBoardClientId: string;
  public lessonStatus: string;
  public whiteBoardId: string;
  public iframeUrl: SafeResourceUrl;

  constructor(private route: ActivatedRoute, private restApi: RestApiService) {}

  ngOnInit(): void {
     this.route.queryParams.subscribe(params => {
      this.lessonInvitationId = params.lessonInvitationId;
      this.token = params.token;
      this.getLessonStatus();
    });
  }

  getLessonStatus(): void {
    const url = this.token ? WHITEBOARD_BY_TOKEN_URL : WHITEBOARD_URL;
    const body = this.token
      ? JSON.stringify({ token: this.token })
      : JSON.stringify({ lessonInvitationId: this.lessonInvitationId });
    this.restApi.postItem(url, body, (response: ApiResponse) => {
      var responseObj = response.responseObject;
      console.log(response.responseObject);
      this.lessonStatus = responseObj.lessonStatus;
      this.whiteBoardClientId = responseObj.whiteBoardClientId;
      this.whiteBoardId = responseObj.whiteBoardId;
      if (this.lessonStatus == 'STARTED') {
        this.initWhiteboard();
      }
    });
  }

  async initWhiteboard() {
    const clientId = this.whiteBoardClientId.slice(-20);
    const boardId = this.whiteBoardId.slice(-22);
    const roomId = `${clientId},${boardId}`;

    this.iframeUrl =
      `https://whiteboard.meteortutors.com/#room=${roomId}`;
  }
}
